import * as React from 'react';
import { useGroundingCommandBarTab_unstable } from './useGroundingCommandBarTab';
import { renderGroundingCommandBarTab_unstable } from './renderGroundingCommandBarTab';
import { useGroundingCommandBarTabStyles_unstable } from './useGroundingCommandBarTabStyles.styles';
import type { GroundingCommandBarTabProps } from './GroundingCommandBarTab.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingCommandBarTab component - TODO: add more docs
export const GroundingCommandBarTab: ForwardRefComponent<GroundingCommandBarTabProps> = React.forwardRef(
  (props, ref) => {
    const state = useGroundingCommandBarTab_unstable(props, ref);

    useGroundingCommandBarTabStyles_unstable(state);
    return renderGroundingCommandBarTab_unstable(state);
  },
);

GroundingCommandBarTab.displayName = 'GroundingCommandBarTab';
